//收据管理（领用）
import request from '@/utils/httpRequest'

export function queryById (id) {
    return request({
        url: '/finance/wuyeFinanceReceiptMaster/queryById',
        method: 'get',
        params: {id: id}
    })
}

export function startFlow(params) {
    return request({
        url: '/finance/wuyeFinanceReceiptMaster/startFlow',
        method: 'post',
        data: params
    })
}